import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = {
  // Products
  getProducts: async (category = null, featured = null) => {
    const params = {};
    if (category) params.category = category;
    if (featured !== null) params.featured = featured;
    const response = await axios.get(`${API}/products`, { params });
    return response.data;
  },

  getProduct: async (sku) => {
    const response = await axios.get(`${API}/products/${sku}`);
    return response.data;
  },

  getCategories: async () => {
    const response = await axios.get(`${API}/categories`);
    return response.data;
  },

  // Orders
  createOrder: async (orderData) => {
    const response = await axios.post(`${API}/orders`, orderData);
    return response.data;
  },

  getOrder: async (orderId) => {
    const response = await axios.get(`${API}/orders/${orderId}`);
    return response.data;
  },

  // Payments
  createPayment: async (paymentData) => {
    const response = await axios.post(`${API}/payments`, paymentData);
    return response.data;
  },

  // Shipping
  getShippingTiers: async () => {
    const response = await axios.get(`${API}/shipping/tiers`);
    return response.data;
  },

  calculateShipping: async (quantity) => {
    const response = await axios.post(`${API}/shipping/calculate`, { quantity });
    return response.data;
  },

  // Wholesale Authentication
  wholesaleRegister: async (clientData) => {
    const response = await axios.post(`${API}/wholesale/register`, clientData);
    return response.data;
  },

  wholesaleLogin: async (email, password) => {
    const response = await axios.post(`${API}/wholesale/login`, { email, password });
    return response.data;
  },

  // Wholesale (authenticated)
  getWholesaleProfile: async (token) => {
    const response = await axios.get(`${API}/wholesale/me`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  getWholesaleProducts: async (token) => {
    const response = await axios.get(`${API}/wholesale/products`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  createWholesaleOrder: async (token, orderData) => {
    const response = await axios.post(`${API}/wholesale/orders`, orderData, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  getWholesaleOrders: async (token) => {
    const response = await axios.get(`${API}/wholesale/orders`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  changeWholesalePassword: async (token, currentPassword, newPassword) => {
    const response = await axios.post(`${API}/wholesale/change-password`, 
      { current_password: currentPassword, new_password: newPassword },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },
};
